import { Dialog, IconButton, Typography } from '@mui/material'
import { Close, ZoomIn, ZoomOut } from '@mui/icons-material'
import useDTMS3Image from 'lib/utils/useDTMS3Image'
import './ViewImageDialog.scss'
import useSubmitImageDialog from 'views/DigitalTrayMapping/CaptureTray/CaptureCamera/SubmitImageDialog/SubmitImageDialog.logic'

interface ViewImageDialogProps {
  open: boolean
  handleClose: () => void
  trayImage: string
}

const ViewImageDialog = ({
  open,
  handleClose,
  trayImage,
}: ViewImageDialogProps) => {
  const { scale, handleZoomIn, handleZoomOut } = useSubmitImageDialog({
    trayImage,
    setTrayImage: () => {},
  })
  const { imageUrl, isLoading } = useDTMS3Image({
    url: trayImage,
    defaultImage: '',
  })

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={handleClose}
      className="view-image-dialog_wrapper"
      sx={{
        '& .MuiDialog-paper': {
          height: '100%',
          minHeight: '-webkit-fill-available',
        },
      }}
    >
      <div className="dialog-content">
        <div className="header">
          <div className="header-left">
            <IconButton className="close-button" onClick={handleClose}>
              <Close />
            </IconButton>
            <Typography className="title">View Tray Image</Typography>
          </div>
        </div>

        <div className="main-content">
          <div className="image-container">
            <div
              className="image-wrapper"
              style={{
                position: 'relative',
                width: '100%',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              {isLoading ? (
                <div className="skeleton-loader" />
              ) : (
                <img
                  src={imageUrl}
                  alt="Tray Preview"
                  className={`preview-image ${isLoading ? 'loading' : ''}`}
                  style={{
                    transform: `translate(-50%, -50%) scale(${scale})`,
                  }}
                />
              )}
            </div>
          </div>

          <div className="bottom-controls">
            <IconButton
              className="control-button"
              onClick={handleZoomOut}
              disabled={scale <= 0.5}
            >
              <ZoomOut />
            </IconButton>
            <IconButton
              className="control-button"
              onClick={handleZoomIn}
              disabled={scale >= 3}
            >
              <ZoomIn />
            </IconButton>
          </div>
        </div>
      </div>
    </Dialog>
  )
}

export default ViewImageDialog
